// Module
var code = `<breadcrumbs></breadcrumbs>
<gl-header>
  <div class="info__column">
      <span class="info__field" ng-repeat="entry in \$ctrl.header">
        <span class="info__field-label">{{entry.label}}:</span>
        <span class="info__value">{{entry.text}}</span>
      </span>
  </div>

  <a class="btn btn-warning"
     ng-href="#!/general-ledger/transactions/{{\$ctrl.ledgerId}}/create"
     command-access="CreateManualLedgerTransaction">
    Add manual
  </a>
  <a class="btn btn-warning"
     ng-href="#!/general-ledger/transactions/{{\$ctrl.ledgerId}}/create-interbranch"
     command-access="InterbranchCreateLedgerTransaction">
    Add manual interbranch
  </a>
  <a class="btn btn-danger"
     ng-href="#!/general-ledger/transactions/{{\$ctrl.ledgerId}}/create-backdated"
     command-access="CreateBackdatedLedgerTransaction">
    Add backdated
  </a>
  <a class="btn btn-danger"
     ng-href="#!/general-ledger/transactions/{{\$ctrl.ledgerId}}/create-backdated-interbranch">
    Add backdated interbranch
  </a>
  <refresh-button on-refresh="\$ctrl.refresh()"></refresh-button>
</gl-header>
<section class="box">
  <sub-header header="'GL transactions'"></sub-header>
<div class="transaction-table-container">
  <div class="filters">
    <div class="labelled-field labelled-field--long">
      <label class="add-on">Posted by</label>
      <selectize id="filter-user"
                 class="nx-selectize"
                 config="\$ctrl.selectConfig"
                 options="\$ctrl.users"
                 ng-model="\$ctrl.filter.userId"></selectize>
    </div>
    <div class="labelled-field labelled-field--long">
      <label for="filter-status" class="add-on">Status</label>
      <select id="filter-status" class="form-control"
              ng-model="\$ctrl.filter.status"
              ng-options="status.label for status in \$ctrl.statuses">
      </select>
    </div>
    <date-range-picker model="\$ctrl.filter.date"></date-range-picker>
  </div>
  <table ng-show="\$ctrl.config.total() > 0"
         class="table table--last-column-to-right transaction-list-table"
         ng-table="\$ctrl.config">
    <tr ng-repeat-start="item in \$data"
        class="table__row--clickable"
        ng-click="\$ctrl.rowClicked(item, \$event)"
        ng-class="{'selected': \$ctrl.selectedTransaction === item.id}"
        class="transaction-item">
      <td data-title="'No'">
        {{item.index + (\$ctrl.config.page() - 1) * \$ctrl.config.count()}}
      </td>
      <td data-title="'System date & time'">{{item.transactionDate}}</td>
      <td data-title="'Backdated'">{{item.backdated | prettyBoolean}}</td>
      <td data-title="'Status'" status="{{item.status}}">{{\$ctrl.resolveLabel(item.status)}}</td>
      <td data-title="'Posting date'" class="posting-date">{{item.postingDate}}</td>
      <td data-title="'Type'" transaction-type="{{item.transactionType}}">
        {{\$ctrl.mapTransactionType(item.transactionType)}}
      </td>
      <td data-title="'User initiating'">{{item.user}}</td>
      <td data-title="'Amount'">{{item.amount | nxCurrency}}</td>
      <td data-title="'Actions'" class="table__actions" ng-if="!item.interbranch">
        <button type="button" ng-if="item.revokeAction"
                command-access="UpdateLedgerTransaction"
                class="btn btn-success"
                ng-click="\$ctrl.modify(item)">
          Modify
        </button>
        <button type="button"
                command-access="RejectManualLedgerTransaction"
                ng-if="item.revokeAction"
                class="btn btn-danger"
                ng-click="\$ctrl.revokeAction(item, \$event)">
          Revoke
        </button>
        <button type="button"
                class="btn btn-success"
                ng-click="\$ctrl.print(item, \$event)">
          Print
        </button>
      </td>
      <td data-title="'Actions'" class="table__actions" ng-if="item.interbranch">
        <!--   disable backdated for now, this will be delivered in a separate ticket   -->
        <button type="button" ng-if="item.revokeAction && !item.backdated"
                command-access="InterbranchUpdateLedgerTransaction"
                class="btn btn-success"
                ng-click="\$ctrl.modifyInterbranch(item)">
          Modify
        </button>
        <button type="button"
                command-access="InterbranchRejectLedgerTransaction"
                ng-if="item.revokeAction"
                class="btn btn-danger"
                ng-click="\$ctrl.revokeAction(item, \$event)">
          Revoke
        </button>
        <button type="button"
                class="btn btn-success"
                ng-click="\$ctrl.print(item, \$event)">
          Print
        </button>
      </td>
    </tr>
    <tr ng-repeat-end class="table__row--not-hoverable">
      <td colspan="100%">
        <div class="toggleable-panel-wrapper"
             ng-class="{'toggleable-panel-wrapper--toggled': \$ctrl.selectedTransaction === item.id}">
          <gl-transaction-details
            transaction="item"
            on-hide="\$ctrl.hideDetailsPanel()"
            on-revoke="\$ctrl.revokeAction(item)"
          >
          </gl-transaction-details>
        </div>
      </td>
    </tr>
  </table>

  <div class="empty-message" ng-hide="\$ctrl.config.total() > 0">
    <span>No transactions matching the given criteria exist.</span>
  </div>
</div>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/general-ledger/transactions/gl-transaction-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;